import Type from './Type';
export function isIBanner(node) {
    return node.type === Type.Banner;
}
export default isIBanner;    //# sourceMappingURL=isIBanner.js.map
